export const regionalCourseTypes = {
  'regionals-free': {
    animation: 'Animated Free courses',
  },
  tamil: {
    animation: 'Animated தமிழ் courses',
    professional: 'Expert தமிழ் courses',
  },
  telugu: {
    animation: 'Animated తెలుగు courses',
  },
  hindi: {
    animation: 'Animated हिन्दी courses',
  },
  kannada: {
    animation: 'Animated ಕನ್ನಡ courses',
  },
  bengali: {
    animation: 'Animated বাংলা courses',
  },
};
